// extracted by mini-css-extract-plugin
export default {"showMoreText":"ShowMoreText_showMoreText__n1u5s"};